import { render, staticRenderFns } from "./factoryStatistics.vue?vue&type=template&id=e31cc250&"
import script from "./factoryStatistics.vue?vue&type=script&lang=js&"
export * from "./factoryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./factoryStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports